
export class ListIdentifier {
  id: string;
  siteId: string;
  webId: string;
  title: string;
  hidden: boolean;
}
